import React, { useState } from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { toast } from "react-toastify";
import { postApi } from "../AppApis";
import { useProfile } from "../../contexts/ProfileContext";
import { showErrorToast } from "../utils";

export default function ReportProperty({ onClose, property, setOpenAuthModal }) {
    const { profileData } = useProfile();

    const [issueType, setIssueType] = useState("");
    const [comment, setComment] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);

    const issueOptions = ["Inappropriate content", "Spam or Fraud", "Misleading Information", "Duplicate Listing"];

    const onSubmit = async () => {
        if (!issueType) {
            return showErrorToast("Please select issue type");
        }

        try {
            const payload = {
                type: issueType,
                propertyid: property?.ListingId,
                comment: comment || "N/A",
            };
            const response = await postApi("/properties/report_property", payload);
            if (response.error === 401) {
                setOpenAuthModal(true);
            } else {
                if (response?.error?.detail) {
                    showErrorToast(response?.error?.detail || "Please try again.");
                } else {
                    setIsSuccess(true);
                }
            }
        } catch (error) {
            console.log("🚀 ~ onSubmit ~ error:", error);
        }
    };
    return (
        <div
            style={{
                zIndex: 100,
            }}
            className="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-justify-center tw-items-center tw-z-50"
        >
            {" "}
            <div onClick={(e) => e.stopPropagation()} className="tw-bg-white tw-rounded-lg tw-shadow-lg tw-w-96 tw-p-6">
                {isSuccess ? (
                    <div className="tw-flex tw-flex-col tw-items-center tw-gap-4">
                        <AiOutlineCheckCircle className="tw-text-green-500 tw-text-5xl" />
                        <p className="tw-text-lg tw-font-semibold">Thank you for your report!</p>
                        <p className="tw-text-center tw-text-gray-600">We will review this issue within 24 hours.</p>
                        <button onClick={onClose} className="tw-bg-green-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md">
                            Go Back
                        </button>
                    </div>
                ) : (
                    <>
                        <div className="tw-flex tw-flex-col">
                            <h2 className="tw-text-lg tw-font-semibold">Report Property</h2>
                            <p className="mt-4 text-gray-600">
                                Please let us know why you're reporting this listing. Our team will review it within 24 hours.
                            </p>
                        </div>
                        <div className="tw-flex tw-flex-col">
                            <label className="block mt-4 text-gray-700 font-medium">Issue Type</label>
                            <select
                                value={issueType}
                                onChange={(e) => setIssueType(e.target.value)}
                                className="w-full mt-2 border border-gray-300 rounded-md p-2"
                            >
                                <option value="" disabled>
                                    Select Issue Type
                                </option>
                                {issueOptions.map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="tw-flex tw-flex-col">
                            <label className="block mt-4 text-gray-700 font-medium">Additional Comments</label>
                            <textarea
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                className="w-full mt-2 border border-gray-300 rounded-md p-2 h-24"
                                placeholder="Provide more details (optional)"
                            />
                        </div>
                        <div className="tw-flex tw-justify-center tw-items-center tw-gap-4">
                            <button
                                onClick={onSubmit}
                                className="tw-mt-4 tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-px-4 tw-py-2 tw-rounded-md"
                            >
                                Submit
                            </button>
                            <button onClick={() => onClose()} className="tw-mt-4 tw-bg-red-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md">
                                Close
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
